import { createContext, RefObject, useContext, useRef } from 'react'

import { Caption, CaptionProps } from 'react-day-picker'

const CaptionContext = createContext<RefObject<HTMLDivElement | null>>({ current: null })

export const usePortalElement = () => {
  return useContext(CaptionContext).current
}

export const DatePickerCaption = (props: CaptionProps) => {
  const portalTargetRef = useRef<HTMLDivElement | null>(null)
  return (
    <CaptionContext.Provider value={portalTargetRef}>
      <Caption {...props} />
      <div ref={portalTargetRef} />
    </CaptionContext.Provider>
  )
}
